<template>
  <div class="Main-Inner">
    <div class="Main-Content">
      <Page :title="$t('About')" style="background-color: #eee;">
        <Layout>
          <LayoutSection>

            <Card :title="$t('Version')">
              <CardSection>
                <TextContainer>
                  <div>{{ $t('User') }}: <strong>{{ version.version }}</strong></div>
                  <div>{{ $t('Server') }}: <strong>{{ theUser.serverVersion }}</strong></div>
                </TextContainer>
              </CardSection>
            </Card>

            <Card :title="$t('Copyrights')">
              <CardSection>
                <TextContainer>
                  <div>Uses icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
                </TextContainer>
              </CardSection>
            </Card>

          </LayoutSection>
        </Layout>
      </Page>
    </div>
  </div>
</template>

<script>

const version = require('../version.json')

export default {
  name: 'About',
  data() {
    return {
      version
    }
  }
}
</script>

<style lang="scss" scoped>
.bookmark {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>